import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { resetAccessInfo, setAccessInfo } from "../../services/accessService/accessService";
import { clearToken, setToken } from "../../services/authentication/authenticationService";

interface AccountState {
  _id?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  role: string;
  profilePic?: string
  token?: string,
  firstLoad: boolean,
  initialized: boolean,
  lastLogin: string | number,
  notificationSettings?: {
    whatsApp: boolean,
    email: boolean,
    sms: boolean
  }
}

const generateEmptyUserState = (): AccountState => {
  return {
    firstLoad: true,
    initialized: false,
    _id: '',
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: 'guest',
    profilePic: '',
    lastLogin: new Date().getTime(),
    token: '',
    notificationSettings: {
      whatsApp: false,
      email: false,
      sms: false
    }
  }
}

const initialState: AccountState = generateEmptyUserState()

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<any>) => {
      if(action.payload.role){
        setAccessInfo({ role: action.payload.role })
      }
      if (action.payload._id) {
        setAccessInfo({ _id: action.payload._id })
      }
      if (action.payload.token) {
        setToken(action.payload.token)
      }
      return {
        ...state,
        ...action.payload,
      }
    },
    logoutUser: () => {
      clearToken()
      resetAccessInfo()
      return generateEmptyUserState()
    }
  },
  // extraReducers: (builder) => {}
})

// Action creators are generated for each case reducer function
export const { setUserInfo, logoutUser } = accountSlice.actions

export const accountSelector = createSelector((state: RootState) => state, (state) => state.account)

export default accountSlice.reducer
